import React from 'react';
import Drawer from 'rc-drawer';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { Button } from 'reactstrap';
import OrgList from 'components/Agile/Organisation/OrgList';
import AppModuleHeader from 'components/AppModuleHeader/index';
import AddOrg from 'components/Agile/Organisation/AddOrg';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';

const filterOptions = [
    {
        id: 1,
        name: 'All organisations',
        icon: 'zmdi-menu'
    }, {
        id: 2,
        name: 'Frequently accessed',
        icon: 'zmdi-time-restore'

    }, {

        id: 3,
        name: 'Starred organisations',
        icon: 'zmdi-star'
    }
];

export class Component extends React.Component {

    OrgSideBar = () => {
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-city-alt mr-4" />
                    <span><IntlMessages id="sidebar.organisations" /></span>
                </div>
            </div>


            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                    style={{ height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                    <div className="module-add-task">
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={this.onAddOrg}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span>Add New Organisation</span>
                        </Button>
                    </div>
                    <div className="module-side-nav">
                        <ul className="module-nav">
                            {filterOptions.map(option => <li key={option.id} className="nav-item">
                                <a href="javascript:void(0)"
                                    className={option.id === this.props.selectedSectionId ? 'active' : ''} onClick={
                                        this.onFilterOrgOptionSelect.bind(this, option)
                                    }>
                                    <i className={`zmdi ${option.icon}`} />
                                    <span>{option.name}</span>
                                </a>
                            </li>
                            )}

                        </ul>
                    </div>
                </CustomScrollbars>
            </div>
        </div>;
    };

    addFavouriteOrg = (data) => {
        this.props.addFavouriteOrg(data);
    };
    onOrgSelect = (data) => {
        this.props.onOrgSelect(data);
    };
    onProjectDashboard = (data) => {
        this.props.onProjectDashboard(data);
    };
    onImpersonateOrg = (data) => {
        this.props.onImpersonateOrg(data);
    };
    onClearSelectedObjects = () => {
        this.props.clearSelectedObjects();
    };
    
    onEmpDashboard = (data) => {
        this.props.onEmpDashboard(data);
    };
    onOrgSurveyDashboard = (data) => {
        this.props.onOrgSurveyDashboard(data);
    }
    onAddOrg = () => {
        this.props.onAddOrg();
    };
    onOrgClose = () => {
        this.props.onOrgClose();
    };
    onFilterOrgOptionSelect = (option) => {
        this.props.onFilterOrgOptionSelect(option);
    };
    onSaveOrg = (data) => {
        this.props.onSaveOrg(data);
    };
    onDeleteOrg = (data) => {
        this.props.onDeleteOrg(data);
    };
    onDeleteSelectedOrg = () => {
        this.props.onDeleteSelectedOrg();
    };
    filterOrg = (orgName) => {
        if (orgName === '') {
            this.onFilterOrgOptionSelect(this.props.filterOption);
        } else {
            this.props.filterOrg(orgName);
        }
    };
    handleOrgRequestClose = () => {
        this.props.handleOrgRequestClose();
    };
    getAllOrg = () => {
        this.props.getAllOrg();
    };
    getUnselectedAllOrg = () => {
        this.props.getUnselectedAllOrg();
    };
    onAllOrgSelect = () => {
        const selectAll = this.props.selectedOrgs < this.props.orgList.length;
        if (selectAll) {
            this.props.getAllOrg();
        } else {
            this.props.getUnselectedAllOrg();
        }
    };
    onToggleOrgDrawer = () => {
        this.props.onToggleOrgDrawer();
    };
    showOrgLoader = () => {
        this.props.showOrgLoader();
    }

    constructor() {
        super();
    }

    componentDidMount() {
        this.props.showOrgLoader();
        this.props.fetchOrgs();
    }


    updateSearchOrg(evt) {
        this.props.updateSearchOrg(evt.target.value);
        this.props.filterOrg(evt.target.value);
    }

    render() {
        const { org, orgList, addOrgState, selectedOrgs, alertMessage, showMessage, drawerState, noContentFoundMessage, loader } = this.props;
        return (
            <div className="app-wrapper">
                <div className="app-module animated slideInUpTiny animation-duration-3">

                    <div className="d-block d-xl-none">
                        <Drawer
                            touch={true}
                            transitions={true}
                            enableDragHandle={true}
                            open={drawerState}
                            onOpenChange={this.onToggleOrgDrawer.bind(this)}
                            sidebar={this.OrgSideBar(org)} />
                    </div>
                    <div className="app-module-sidenav d-none d-xl-flex">
                        {this.OrgSideBar(org)}
                    </div>

                    <div className="module-box">
                        <div className="module-box-header">
                            <span className="icon-btn drawer-btn d-flex d-xl-none"
                                onClick={this.onToggleOrgDrawer.bind(this)}>
                                <i className="zmdi zmdi-menu" />
                            </span>
                            <AppModuleHeader placeholder="Search org" notification={false} apps={false}
                                user={this.props.org}
                                onChange={this.updateSearchOrg.bind(this)}
                                value={this.props.searchOrg} />
                        </div>
                        <div className="module-box-content">

                            <div className="module-box-topbar align-items-center">
                                <div className="form-control-checkbox d-flex">
                                    <div className="form-checkbox">
                                        <input type="checkbox"
                                            checked={selectedOrgs > 0}
                                            onChange={this.onAllOrgSelect.bind(this)} />
                                        <span className="check">
                                            <i className="zmdi zmdi-check zmdi-hc-lg" />
                                        </span>
                                    </div>
                                </div>

                                <Button size="sm" className="jr-btn jr-flat-btn" color="default"
                                    onClick={this.onDeleteSelectedOrg.bind(this)} >
                                    <i className="zmdi zmdi-filter-list zmdi-hc-fw" />
                                    <span><IntlMessages id="label.filter.selected" /></span>
                                </Button>
                            </div>
                            <CustomScrollbars className="module-list-scroll scrollbar"
                                style={{ height: this.props.width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)' }}>
                                {loader ?
                                    <div
                                        className="loader-view-block h-100">
                                        <div className="loader-view">
                                            <CircularProgress />
                                        </div>
                                    </div>
                                    :
                                    orgList && orgList.length > 0 ?
                                        <OrgList data={orgList}
                                            addFavouriteOrg={this.addFavouriteOrg.bind(this)}
                                            onOrgSelect={this.onOrgSelect.bind(this)}
                                            onDeleteOrg={this.onDeleteOrg.bind(this)}
                                            onSaveOrg={this.onSaveOrg.bind(this)}
                                            showOrgLoader={this.showOrgLoader.bind(this)}
                                            onEmpDashboard={this.onEmpDashboard.bind(this)} 
                                            onProjectDashboard={this.onProjectDashboard.bind(this)} 
                                            onImpersonateOrg={this.onImpersonateOrg.bind(this)}
                                            onClearSelectedObjects={this.onClearSelectedObjects.bind(this)}
                                            onOrgSurveyDashboard={this.onOrgSurveyDashboard.bind(this)} />
                                        :
                                        <div className="h-100 d-flex align-items-center justify-content-center">
                                            {noContentFoundMessage}
                                        </div>
                                }
                            </CustomScrollbars>

                        </div>
                    </div>
                </div>
                <AddOrg
                    open={addOrgState}
                    organisation={{
                        'id': '',
                        'name': '',
                        'thumb': null,
                        'email': '',
                        'phone': '',
                        'designation': '',
                        'selected': false,
                        'starred': false,
                        'frequently': false,
                        'role': '',
                        'surveys': [],
                    }}
                    onSaveOrg={this.onSaveOrg}
                    onOrgClose={this.onOrgClose}
                    onDeleteOrg={this.onDeleteOrg}
                    showOrgLoader={this.showOrgLoader}
                />

                {showMessage && NotificationManager.success(alertMessage, this.handleOrgRequestClose())}
                <NotificationContainer />

            </div>
        );
    }
}

export default Component;



// WEBPACK FOOTER //
// ./components/Agile/organisation/component.js